<moti-popover-message
  [infoText]="infoText"
  [infoHtml]="infoHtml"
>
  <i class="fa-solid fa-{{icon.id}}"></i>
</moti-popover-message>
